import { atomWithReset } from 'jotai/utils';

export const $LikeCountConfirmModalStatus = atomWithReset<boolean>(false);
